import { REDUX } from "../../constants";

export const setLoggedUser = (user) => {
  return { type: REDUX.LOGGED_USER, user };
};
export const logoutUser = () => {
  return { type: REDUX.LOGOUT_USER };
};